import React from "react";
import { useTranslation } from "react-i18next";

import DropDownMenu from "../../DropDownMenu";
import { Button } from '../../Buttons';


import "./pointDropdown.scss";
import { CoinIcon } from "../../../../assets";

function PointDropdown({ setVisibleLeaderboardModal }) {
  const { t } = useTranslation();
  return (
    <DropDownMenu customClassName="point-menu-container">
      <div className="points-menu">
        <img src={CoinIcon} className="coin-icon" alt='Coin' />
        <div className="points-menu-content">
          <h4>{t("points")}</h4>
          <p>{t("pointsDropdownText")}</p>
          <Button
            label={t("goToLeaderboard")}
            iconClassName="hasIcon--chevron-right"
            viewType="noBorderBig"
            onClick={() => setVisibleLeaderboardModal(true)}
          />
        </div>
      </div>
    </DropDownMenu>
  );
}

export default PointDropdown;
